import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="mt-16 bg-slate-800 text-slate-300">
      <div className="mx-auto flex max-w-5xl flex-col gap-4 px-4 py-10 sm:flex-row sm:items-center sm:justify-between sm:px-6">
        <div>
          <p className="font-display text-lg font-bold text-white">Prestadores Online</p>
          <p className="text-base">Goiânia e região metropolitana</p>
        </div>
        <nav className="flex flex-wrap gap-5 text-base">
          <Link to="/termos" className="underline-offset-4 hover:text-white hover:underline" data-testid="footer-terms">Termos de uso</Link>
          <Link to="/privacidade" className="underline-offset-4 hover:text-white hover:underline" data-testid="footer-privacy">Privacidade</Link>
          <Link to="/perfil/prestador" className="underline-offset-4 hover:text-white hover:underline" data-testid="footer-provider">Sou prestador</Link>
        </nav>
      </div>
    </footer>
  );
}
